module.exports = __webpack_public_path__ + "img/null.5a47354c.png";